export const parseSearchString = ( string ) => {
	if ( string === '' )
	{
		return {};
	}

	return JSON.parse( '{"' + string.slice( 1 ).split( "&" ).map( ( it ) => /=/.test( it ) ? it.replace( '=', '":"' ) : it + '":"true' ).join( '","' ) + '"}' );
};